import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import BredCrumb from "../Global/BredCrumb";
import LazySection from "../Global/LazySection";
import ErrorBoundary from "../Global/ErrorBoundary";

// Lazy load heavy components
const Footer = lazy(() => import("../Global/Footer"));
const GoToTop = lazy(() => import("../Global/GoToTop"));
const ProdukLogo = lazy(() => import("./ProdukLogo"));
const LogoApplications = lazy(() => import("./LogoApplications"));
const ModelGallery = lazy(() => import("./ModelGallery"));
const Call = lazy(() => import("../Menhomeone/Call"));

// Loading fallback component
const LoadingFallback = ({ message = "Memuat konten..." }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '60px 20px',
    minHeight: '400px',
  }}>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '15px',
    }}>
      <div style={{
        width: '50px',
        height: '50px',
        border: '4px solid rgba(102, 126, 234, 0.2)',
        borderTop: '4px solid #667eea',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}></div>
      <p style={{ color: '#667eea', fontSize: '16px', fontWeight: '600' }}>
        {message}
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  </div>
);

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Woven Patch &amp; Badge Premium | Logo Woven Mina</title>
        <meta name="description" content="Woven patch dan badge premium custom untuk jaket, tas, dan aksesoris. Desain detail dan tahan lama. Pesan woven patch di Logo Woven Mina." />
        <link rel="canonical" href="https://www.logowovenmina.com/logo" />
      </Helmet>
      <Preloader />
      <Header />
      <BredCrumb Title="Woven Patch & Badge Premium" subtitle="Logo" />
      <div className="page_wrapper">
        <LazySection>
          <Suspense fallback={null}>
            <LogoApplications />
          </Suspense>
        </LazySection>

        <LazySection minHeight="600px">
          <ErrorBoundary
            title="Model 3D tidak dapat dimuat"
            message="Perangkat Anda mungkin tidak mendukung tampilan 3D. Silakan lanjutkan scrolling untuk melihat konten lainnya."
          >
            <Suspense fallback={<LoadingFallback message="Memuat Model 3D..." />}>
              <ModelGallery />
            </Suspense>
          </ErrorBoundary>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <ProdukLogo />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Call />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        </LazySection>

        <Suspense fallback={null}>
          <GoToTop />
        </Suspense>
      </div>
    </>
  );
};
export default Main;
